// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#page:has(.main_header) #content > div {\n  padding-top: calc(var(--headerHeight) + var(--gap_big));\n}\n#page:has(#main_login_signup) #content {\n  padding: 0;\n}\n#content {\n  background: var(--pageBG);\n  min-height: 100vh;\n}\n#content > div {\n  padding-top: calc(var(--gap_big));\n  min-height: 100vh;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
